import React from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes';
import {t} from "../../../lang/index";

const AboutSection = () => {
    const routes = all_routes

    return (
        <>
            {/* About Section */}
            <section className="section about">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="about-image mb-4 mb-lg-0">
                                <div className="about-listing">
                                    <i className="isax isax-calendar-add text-white mb-2" />
                                    <h6 className="fs-16 mb-3 text-white">All Listings</h6>
                                    <div className="listing-img">
                                        <div>
                                            <ImageWithBasePath src="assets/img/icons/listing.svg" alt="icon" />
                                        </div>
                                    </div>
                                </div>
                                <div className="about-img">
                                    <ImageWithBasePath src="assets/img/about.png" alt="about" />
                                </div>
                                <div className="about-progress d-inline-flex align-items-center">
                                    <ImageWithBasePath src="assets/img/icons/progress-icon.svg" alt="icon" />
                                    <div className="ms-2">
                                        <p className="fs-10 mb-1">Today’s Earnings</p>
                                        <h6 className="fs-13">$2500</h6>
                                    </div>
                                    <Link
                                        to={""}
                                        className="btn btn-teal btn-sm fw-normal ms-4"
                                    >
                                        Withdraw
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-content mb-4">
                                <h6 className="text-primary fs-14 fw-medium mb-2">
                                    {t("home.aboutSection.welcome")}
                                </h6>
                                <h2 className="display-6 mb-2">
                                    {t("home.aboutSection.title")}
                                </h2>
                                <p className="mb-4">
                                    {t("home.aboutSection.description1")}
                                </p>
                                <div className="d-flex align-items-center mb-4">
                                    <span className="avatar avatar-xl bg-primary rounded-circle flex-shrink-0 me-3">
                                        <i className="isax isax-map5 fs-24" />
                                    </span>
                                    <p>
                                        {t("home.aboutSection.point1")}
                                    </p>
                                </div>
                                <div className="d-flex align-items-center">
                                    <span className="avatar avatar-xl bg-secondary rounded-circle flex-shrink-0 me-3">
                                        <i className="isax isax-trade5 fs-24 text-gray-9" />
                                    </span>
                                    <p>
                                        {t("home.aboutSection.point2")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="about-bg d-none d-md-block">
                        <ImageWithBasePath
                            src="assets/img/bg/about-bg.png"
                            alt="img"
                            className="about-bg-01"
                        />
                    </div>
                    <div className="about-bg-1 d-none d-md-block">
                        <ImageWithBasePath
                            src="assets/img/bg/about-arrow.png"
                            alt="img"
                            className="about-bg-01"
                        />
                    </div>
                </div>
            </section>
            {/* /About Section */}
        </>

    )
}

export default AboutSection
